// import React from "react";
// // import bg from "../../assets/term-and-condition.jpeg";
// import { Link } from "react-router-dom";
// import { Helmet } from "react-helmet-async";

// const TermsAndConditions = () => {
//   return (
//     <>
//       {/* ✅ SEO START */}
//       <Helmet>
//         <title>Terms and Conditions | LMSBots</title>

//         <meta
//           name="description"
//           content="Read the Terms and Conditions of LMSBots. Understand your rights, responsibilities, billing policies, and service usage guidelines."
//         />

//         <meta
//           name="keywords"
//           content="LMSBots terms, CRM terms, lead management terms, SaaS agreement, LMSBots policies"
//         />

//         <meta name="author" content="LMSBots" />

//         {/* Open Graph (Social Sharing) */}
//         <meta property="og:title" content="Terms and Conditions | LMSBots" />
//         <meta
//           property="og:description"
//           content="Official Terms and Conditions for using LMSBots CRM and Lead Management platform."
//         />
//         <meta property="og:type" content="website" />
//         <meta property="og:url" content="https://lmsbots.com/terms" />

//         {/* Twitter */}
//         <meta name="twitter:card" content="summary_large_image" />
//         <meta name="twitter:title" content="Terms and Conditions | LMSBots" />
//         <meta
//           name="twitter:description"
//           content="Understand LMSBots policies, usage terms, and legal guidelines."
//         />

//         {/* Canonical URL */}
//         <link rel="canonical" href="https://lmsbots.com/terms" />
//       </Helmet>

//       <div className="max-w-5xl mx-auto px-4  py-10 pt-24 text-gray-800">
//         <h2 className="text-2xl sm:text-4xl bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent font-semibold text-left text-gray-800 mb-1 md:mb-1">
//           Terms and Conditions
//         </h2>
//         <div className="w-28 h-1 mx-auto bg-main rounded mb-3" />

//         <div className="mb-4">
//           <h2 className="md:text-xl text-lg font-semibold mb-1">
//             1. Introduction
//           </h2>
//           <p className="md:text-base text-sm">
//             Welcome to <span className="font-semibold">LMS Bots</span>, a
//             provider of and
//             <span className="font-semibold"> CRM solutions</span> services.
//             These Terms and Conditions ("Terms") govern your use of our website
//             and services. By accessing or using our services, you agree to be
//             bound by these Terms.
//           </p>
//         </div>

//         <div className="mb-4">
//           <h2 className="md:text-xl text-lg font-semibold mb-1">2. Services</h2>
//           <p className="md:text-base text-sm">
//             We provide{" "}
//             <span className="font-semibold">
//               Lead Management System setup, configuration, and CRM integration
//             </span>{" "}
//             services. The services are provided{" "}
//             <span className="italic ">"as-is"</span> and may change or evolve
//             over time. We reserve the right to modify or discontinue services
//             without notice.
//           </p>
//         </div>

//         <div className="mb-4">
//           <h2 className="md:text-xl text-lg font-semibold mb-1">
//             3. Eligibility
//           </h2>
//           <p className="md:text-base text-sm">
//             You must be at least{" "}
//             <span className="font-semibold">18 years of age</span> and legally
//             capable of entering into a binding contract to use our services. By
//             using our services, you represent and warrant that you meet these
//             requirements.
//           </p>
//         </div>

//         <div className="mb-4">
//           <h2 className="text-xl font-semibold mb-1">
//             4. User Responsibilities
//           </h2>
//           <ul className="md:text-base text-sm list-disc ">
//             <li>
//               <span className="font-semibold">
//                 Provide accurate and complete information
//               </span>{" "}
//               when registering or using our services.
//             </li>
//             <li>
//               <span className="font-semibold">Maintain confidentiality</span> of
//               your account credentials and login information.
//             </li>
//             <li>
//               <span className="font-semibold">Do not misuse</span> our services
//               or use them for unlawful purposes.
//             </li>
//             <li>
//               <span className="font-semibold">Ensure data accuracy</span> for
//               all leads and customer information entered into the system.
//             </li>
//             <li>
//               <span className="font-semibold">Comply with data protection</span>{" "}
//               and privacy laws when handling customer information.
//             </li>
//           </ul>
//         </div>

//         <div className="mb-4">
//           <h2 className="md:text-xl text-lg font-semibold mb-1">
//             5. Payment & Billing
//           </h2>
//           <ul className="list-disc  md:text-base text-sm">
//             <li>
//               <span className="font-semibold">All payments</span> are to be made
//               in favour of{" "}
//               <span className="font-semibold">Deetya Soft Pvt. Ltd.</span>
//             </li>
//             <li>
//               <span className="font-semibold">
//                 Applicable taxes, levies, and charges
//               </span>{" "}
//               will be charged as per prevailing rates.
//             </li>
//             <li>
//               <span className="font-semibold">Minimum Contract Period</span> is{" "}
//               <span className="font-semibold">12 months</span>. If terminated
//               early, the customer must pay full charges for the contract period.
//             </li>
//             <li>
//               <span className="font-semibold">Auto-renewal:</span> The contract
//               renews automatically unless either party gives a{" "}
//               <span className="font-semibold">30-day written notice</span>.
//             </li>
//             <li>
//               <span className="font-semibold">Termination Notice:</span> Minimum{" "}
//               <span className="font-semibold">30 days</span> or as per agreed
//               payment terms, whichever is less.
//             </li>
//             <li>
//               <span className="font-semibold">
//                 Standard implementation period
//               </span>{" "}
//               is <span className="font-semibold">2 weeks</span> from requirement
//               finalization, subject to mutually agreed lead times.
//             </li>
//             <li>
//               <span className="font-semibold">Non-payment:</span> If bills
//               remain unpaid beyond <span className="font-semibold">4 days</span>
//               , services will be deactivated.
//             </li>
//             <li>
//               <span className="font-semibold">
//                 User licenses and storage limits
//               </span>{" "}
//               are defined in the service agreement. Additional users or storage
//               will incur extra charges.
//             </li>
//             <li>
//               <span className="font-semibold">Customer data</span> will be
//               retained for <span className="font-semibold">30 days</span> after
//               termination, after which it will be permanently deleted.
//             </li>
//           </ul>
//         </div>

//         <div className="mb-4">
//           <h2 className="md:text-xl text-lg font-semibold mb-1">
//             6. Data Security & Privacy
//           </h2>
//           <p className="md:text-base text-sm">
//             We implement{" "}
//             <span className="font-semibold">
//               industry-standard security measures
//             </span>{" "}
//             to protect your data. All lead and customer information is encrypted
//             and stored securely. You are responsible for maintaining the
//             confidentiality of your account credentials. Please refer to our{" "}
//             <Link
//               to="/privacy-policy"
//               className="text-blue-600 hover:underline font-semibold"
//             >
//               Privacy Policy
//             </Link>{" "}
//             for detailed information on how we handle your data.
//           </p>
//         </div>

//         <div className="mb-4">
//           <h2 className="md:text-xl text-lg font-semibold mb-1">
//             7. Intellectual Property
//           </h2>
//           <p className="md:text-base text-sm">
//             All{" "}
//             <span className="font-semibold">
//               content, trademarks, logos, software, and system features
//             </span>{" "}
//             related to our services are the intellectual property of{" "}
//             <span className="font-semibold">Deetya Soft Pvt. Ltd.</span>. You
//             may not copy, reproduce, reverse engineer, or distribute any part of
//             our services without written consent.
//           </p>
//         </div>

//         <div className="mb-4">
//           <h2 className="md:text-xl text-lg font-semibold mb-1">
//             8. Limitation of Liability
//           </h2>
//           <p className="md:text-base text-sm">
//             We are{" "}
//             <span className="font-semibold">not liable for any damages</span>,
//             direct or indirect, resulting from the use or inability to use our
//             services, including but not limited to{" "}
//             <span className="font-semibold">
//               data loss, service interruptions, or business disruptions
//             </span>
//             . Our total liability shall not exceed the amount paid by you for
//             the services during the preceding 12 months.
//           </p>
//         </div>

//         <div className="mb-4">
//           <h2 className="md:text-xl text-lg font-semibold mb-1">
//             9. Privacy Policy
//           </h2>
//           <p className="text-base">
//             Please refer to our{" "}
//             <Link
//               to="/privacy-policy"
//               className="text-blue-600 hover:underline font-semibold"
//             >
//               Privacy Policy
//             </Link>{" "}
//             to understand how we{" "}
//             <span className="font-semibold">collect, use, and protect</span>{" "}
//             your personal information.
//           </p>
//         </div>

//         <div className="mb-4">
//           <h2 className="md:text-xl text-lg font-semibold mb-1">
//             10. Termination
//           </h2>
//           <p className="md:text-base text-sm">
//             We reserve the right to{" "}
//             <span className="font-semibold">suspend or terminate</span> your
//             access to our services at any time if we believe you have violated
//             these Terms or engaged in any harmful behavior. Upon termination,
//             you must cease all use of our services and return or destroy any
//             confidential information.
//           </p>
//         </div>

//         <div className="mb-4">
//           <h2 className="md:text-xl text-lg font-semibold mb-1">
//             11. Changes to Terms
//           </h2>
//           <p className="md:text-base text-sm">
//             We may <span className="font-semibold">update these Terms</span>{" "}
//             from time to time. Continued use of the services after such changes
//             implies your acceptance of the updated Terms. We will notify you of
//             material changes via email or through the platform.
//           </p>
//         </div>

//         <div className="mb-4">
//           <h2 className="md:text-xl text-lg font-semibold mb-1">
//             12. Contact Us
//           </h2>
//           <p className="md:text-base text-sm">
//             If you have any questions or concerns about these Terms, please
//             contact us at
//             <a
//               href="mailto:support@deetyasoft.com"
//               className="text-blue-600 hover:underline font-semibold"
//             >
//               {" "}
//               support@deetyasoft.com
//             </a>
//             .
//           </p>
//         </div>
//       </div>
//     </>
//   );
// };

// export default TermsAndConditions;






import React from "react";
import { Link } from "react-router-dom";
import Seo, { SITE_URL } from "../../WebsiteComponents/Seo";
import { ROUTES } from "../../seoData";

const PATH = "/terms-and-conditions";
const TITLE = ROUTES[PATH].title;
const DESCRIPTION = ROUTES[PATH].description;

const LAST_UPDATED = "Effective as of the date of acceptance";

const SECTIONS = [
  {
    id: "introduction",
    title: "Introduction",
    body: (
      <p>
        Welcome to <strong>LMSBOTS</strong>, a provider of CRM and lead
        management solutions. These Terms and Conditions ("Terms") govern your
        access to and use of our website and services. By accessing or using our
        services, you agree to be bound by these Terms.
      </p>
    ),
  },
  {
    id: "services",
    title: "Services",
    body: (
      <p>
        We provide <strong>Lead Management System setup, configuration, and CRM
        integration</strong> services. The services are provided{" "}
        <em>“as is”</em> and may change or evolve over time. We reserve the
        right to modify or discontinue services without prior notice.
      </p>
    ),
  },
  {
    id: "eligibility",
    title: "Eligibility",
    body: (
      <p>
        You must be at least <strong>18 years of age</strong> and legally capable
        of entering into a binding contract to use our services. By using our
        services, you represent and warrant that you meet these requirements.
      </p>
    ),
  },
  {
    id: "user-responsibilities",
    title: "User responsibilities",
    body: (
      <ul className="mt-3 list-disc space-y-2 pl-5">
        <li>
          <strong>Provide accurate and complete information</strong> when
          registering or using our services.
        </li>
        <li>
          <strong>Maintain the confidentiality</strong> of your account
          credentials and login information.
        </li>
        <li>
          <strong>Do not misuse</strong> our services or use them for unlawful
          purposes.
        </li>
        <li>
          <strong>Ensure data accuracy</strong> for all leads and customer
          information entered into the system.
        </li>
        <li>
          <strong>Comply with data protection</strong> and privacy laws when
          handling customer information.
        </li>
      </ul>
    ),
  },
  {
    id: "payment-and-billing",
    title: "Payment & billing",
    body: (
      <ul className="mt-3 list-disc space-y-2 pl-5">
        <li>
          <strong>All payments</strong> are to be made in favour of{" "}
          <strong>Deetya Soft Pvt. Ltd.</strong>
        </li>
        <li>
          <strong>Applicable taxes, levies, and charges</strong> will be charged
          as per prevailing rates.
        </li>
        <li>
          <strong>Minimum contract period</strong> is <strong>12 months</strong>.
          If terminated early, the customer must pay full charges for the
          contract period.
        </li>
        <li>
          <strong>Auto-renewal:</strong> The contract renews automatically
          unless either party gives a <strong>30-day written notice</strong>.
        </li>
        <li>
          <strong>Termination notice:</strong> minimum <strong>30 days</strong>{" "}
          or as per agreed payment terms, whichever is less.
        </li>
        <li>
          <strong>Standard implementation period</strong> is{" "}
          <strong>2 weeks</strong> from requirement finalisation, subject to
          mutually agreed lead times.
        </li>
        <li>
          <strong>Non-payment:</strong> if bills remain unpaid beyond{" "}
          <strong>4 days</strong>, services will be deactivated.
        </li>
        <li>
          <strong>User licences and storage limits</strong> are defined in the
          service agreement. Additional users or storage will incur extra
          charges.
        </li>
        <li>
          <strong>Customer data</strong> will be retained for{" "}
          <strong>30 days</strong> after termination, after which it will be
          permanently deleted.
        </li>
      </ul>
    ),
  },
  {
    id: "data-security-and-privacy",
    title: "Data security & privacy",
    body: (
      <p>
        We implement <strong>industry-standard security measures</strong> to
        protect your data. All lead and customer information is encrypted and
        stored securely. You are responsible for maintaining the
        confidentiality of your account credentials. Please refer to our{" "}
        <Link
          to="/privacy-policy"
          className="font-medium text-[#48247f] underline decoration-[#702cb0]/40 underline-offset-2 hover:text-[#702cb0]"
        >
          Privacy Policy
        </Link>{" "}
        for detailed information on how we handle your data.
      </p>
    ),
  },
  {
    id: "intellectual-property",
    title: "Intellectual property",
    body: (
      <p>
        All <strong>content, trademarks, logos, software, and system
        features</strong> related to our services are the intellectual property of{" "}
        <strong>Deetya Soft Pvt. Ltd.</strong> You may not copy, reproduce,
        reverse engineer, or distribute any part of our services without prior
        written consent.
      </p>
    ),
  },
  {
    id: "limitation-of-liability",
    title: "Limitation of liability",
    body: (
      <p>
        We are <strong>not liable for any damages</strong>, direct or indirect,
        resulting from the use or inability to use our services, including but
        not limited to <strong>data loss, service interruptions, or business
        disruptions</strong>. Our total liability shall not exceed the amount
        paid by you for the services during the preceding 12 months.
      </p>
    ),
  },
  {
    id: "privacy-policy",
    title: "Privacy policy",
    body: (
      <p>
        Please refer to our{" "}
        <Link
          to="/privacy-policy"
          className="font-medium text-[#48247f] underline decoration-[#702cb0]/40 underline-offset-2 hover:text-[#702cb0]"
        >
          Privacy Policy
        </Link>{" "}
        to understand how we <strong>collect, use, and protect</strong> your
        personal information.
      </p>
    ),
  },
  {
    id: "termination",
    title: "Termination",
    body: (
      <p>
        We reserve the right to <strong>suspend or terminate</strong> your
        access to our services at any time if we believe you have violated
        these Terms or engaged in harmful behaviour. Upon termination, you must
        cease all use of our services and return or destroy any confidential
        information.
      </p>
    ),
  },
  {
    id: "changes-to-terms",
    title: "Changes to these terms",
    body: (
      <p>
        We may <strong>update these Terms</strong> from time to time. Continued
        use of the services after such changes implies your acceptance of the
        updated Terms. We will notify you of material changes via email or
        through the platform.
      </p>
    ),
  },
  {
    id: "contact-us",
    title: "Contact us",
    body: (
      <p>
        If you have any questions or concerns about these Terms, please contact
        us at{" "}
        <a
          href="mailto:support@deetyasoft.com"
          className="font-medium text-[#48247f] underline decoration-[#702cb0]/40 underline-offset-2 hover:text-[#702cb0]"
        >
          support@deetyasoft.com
        </a>
        .
      </p>
    ),
  },
];

const JSON_LD = [
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": `${SITE_URL}${PATH}#webpage`,
    url: `${SITE_URL}${PATH}`,
    name: TITLE,
    description: DESCRIPTION,
    inLanguage: "en-IN",
    isPartOf: { "@id": `${SITE_URL}/#website` },
    about: { "@id": `${SITE_URL}/#organization` },
    breadcrumb: { "@id": `${SITE_URL}${PATH}#breadcrumb` },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "@id": `${SITE_URL}${PATH}#breadcrumb`,
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
      { "@type": "ListItem", position: 2, name: "Terms & Conditions", item: `${SITE_URL}${PATH}` },
    ],
  },
];

const TermsAndConditions = () => {
  return (
    <>
      <Seo title={TITLE} description={DESCRIPTION} path={PATH} jsonLd={JSON_LD} />

      <div
        className="w-full overflow-x-clip bg-white font-sans text-[#28194f] antialiased"
      >
        {/* ================= HERO (light surface, hero palette accents) ================= */}
        <section
          aria-labelledby="terms-heading"
          className="relative isolate w-full overflow-hidden bg-gradient-to-b from-[#f6f3fc] via-white to-white"
        >
          <div
            className="pointer-events-none absolute inset-0 -z-10 opacity-40"
            style={{
              backgroundImage: "radial-gradient(#48247f18 1px, transparent 1px)",
              backgroundSize: "22px 22px",
              WebkitMaskImage: "radial-gradient(ellipse at 40% 40%, black 30%, transparent 80%)",
              maskImage: "radial-gradient(ellipse at 40% 40%, black 30%, transparent 80%)",
            }}
          />
          <div className="pointer-events-none absolute -right-24 -top-24 -z-10 h-72 w-72 rounded-full bg-[#702cb0]/10 blur-3xl sm:h-96 sm:w-96" />
          <div className="pointer-events-none absolute -left-24 bottom-0 -z-10 h-64 w-64 rounded-full bg-[#12dfbd]/12 blur-3xl sm:h-80 sm:w-80" />

          <div className="relative z-10 mx-auto w-full max-w-[1300px] px-4 pb-12 pt-20 text-center sm:px-8 sm:pb-14 sm:pt-24 md:px-10 lg:px-14 lg:pb-16 lg:pt-32 xl:px-20">
            <div className="mx-auto mb-5 inline-flex items-center gap-2 rounded-full border border-[#48247f]/15 bg-white px-3 py-1 text-[11px] font-medium text-[#48247f] shadow-sm sm:mb-6 sm:text-xs">
              <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#12dfbd]" />
              Legal · LMSBOTS
            </div>

            <h1
              id="terms-heading"
              className="mx-auto max-w-3xl text-balance text-[26px] font-light leading-[1.2] tracking-tight sm:text-[32px] md:text-[36px] lg:text-[40px] xl:text-[44px]"
            >
              Terms &amp;{" "}
              <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
                Conditions
              </span>
            </h1>

            <p className="mx-auto mt-4 max-w-[640px] text-sm font-light leading-[1.75] text-[#3b2a63] sm:text-base lg:text-[17px]">
              The rules that apply when you use LMSBOTS. Plain-language summary
              of the full agreement, which you accept when you use the platform.
            </p>

            <p className="mx-auto mt-4 text-[11px] font-medium text-[#702cb0]/80 sm:text-xs">
              {LAST_UPDATED}
            </p>
          </div>
        </section>

        {/* ================= BODY ================= */}
        <section
          aria-labelledby="terms-body-heading"
          className="relative w-full bg-white py-12 sm:py-14 lg:py-20"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-8 md:px-10 lg:px-14">
            <div className="grid gap-8 lg:grid-cols-12 lg:gap-12">
              {/* TOC sidebar */}
              <aside
                aria-label="Table of contents"
                className="lg:col-span-4 lg:sticky lg:top-24 lg:self-start"
              >
                <div className="rounded-2xl border border-[#48247f]/10 bg-white p-5 shadow-[0_8px_30px_-12px_rgba(72,36,127,0.22)] sm:p-6">
                  <h2 className="text-[11px] font-semibold uppercase tracking-[0.14em] text-[#702cb0]/80">
                    On this page
                  </h2>
                  <ol className="mt-3 space-y-1.5">
                    {SECTIONS.map((s, i) => (
                      <li key={s.id}>
                        <a
                          href={`#${s.id}`}
                          className="group flex items-start gap-2 rounded-md px-2 py-1.5 text-sm text-[#3b2a63] transition-colors hover:bg-[#f6f3fc] hover:text-[#48247f] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#702cb0] focus-visible:ring-offset-2"
                        >
                          <span className="mt-0.5 text-[11px] font-semibold text-[#702cb0]/70">
                            {String(i + 1).padStart(2, "0")}
                          </span>
                          <span className="leading-snug">{s.title}</span>
                        </a>
                      </li>
                    ))}
                  </ol>
                </div>
              </aside>

              {/* Sections */}
              <div className="lg:col-span-8">
                <div className="rounded-2xl border border-[#48247f]/10 bg-white p-5 shadow-[0_8px_30px_-12px_rgba(72,36,127,0.22)] sm:p-8 lg:p-10">
                  <h2
                    id="terms-body-heading"
                    className="text-balance text-[22px] font-light leading-[1.25] tracking-tight text-[#28194f] sm:text-[26px] md:text-[30px]"
                  >
                    The full{" "}
                    <span className="bg-gradient-to-r from-[#48247f] to-[#702cb0] bg-clip-text font-normal text-transparent">
                      agreement
                    </span>
                  </h2>
                  <p className="mt-2 text-sm leading-[1.75] text-[#3b2a63]">
                    Each section below covers one part of your agreement with
                    LMSBOTS. Use the sidebar to jump to a topic.
                  </p>

                  <div className="mt-8 space-y-8">
                    {SECTIONS.map((s, i) => (
                      <article
                        key={s.id}
                        id={s.id}
                        aria-labelledby={`${s.id}-heading`}
                        className="scroll-mt-24"
                      >
                        <h3
                          id={`${s.id}-heading`}
                          className="text-lg font-medium tracking-tight text-[#28194f] sm:text-xl"
                        >
                          <span className="mr-2 text-[11px] font-semibold align-top text-[#702cb0]/70">
                            {String(i + 1).padStart(2, "0")}
                          </span>
                          {s.title}
                        </h3>
                        <div className="mt-2 text-sm leading-[1.8] text-[#3b2a63] sm:text-[15px]">
                          {s.body}
                        </div>
                      </article>
                    ))}
                  </div>
                </div>

                <p className="mt-6 text-center text-xs text-slate-500 sm:text-sm">
                  Questions about these Terms?{" "}
                  <a
                    href="mailto:support@deetyasoft.com"
                    className="font-medium text-[#48247f] hover:underline"
                  >
                    Email our team
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default TermsAndConditions;